// extracted by mini-css-extract-plugin
export default {"navBar":"route_navBar__Wc5QI","logo":"route_logo__RKw5u"};